(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atri-included-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-atri-card-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.atriCardOpen);
      if (dialog && !dialog.open) dialog.showModal();
    }
    if (event.target.matches('dialog.atri-included-card__dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atri-newsletter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atri-newsletter')) {
    customElements.define('atri-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        if (!this.form.querySelector('button[type="submit"]')) return;
        // Install the transport before Shopify wraps form.submit to obtain its token.
        // An already-bound form retains its native, protected submission as a fallback.
        if (this.form.hasAttribute('data-hcaptcha-bound') || this.form.hasAttribute('data-recaptcha-bound')) return;
        this.form.submit = () => this.send();
        this.ready = new Promise((resolve) => {
          if (window.Shopify?.captcha?.protect) window.Shopify.captcha.protect(this.form, resolve);
          else resolve();
        });
        this.form.addEventListener('submit', async (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.busy || !this.form.reportValidity()) return;
          this.setBusy(true);
          this.querySelector('.atri-letter__error').hidden = true;
          this.querySelector('[type="email"]').removeAttribute('aria-invalid');
          this.querySelector('[type="email"]').removeAttribute('aria-describedby');
          this.controller = new AbortController();
          this.timeout = setTimeout(() => {
            this.controller.abort();
            this.fail();
          }, 45000);
          try {
            await this.ready;
            if (this.busy) this.form.submit();
          } catch (error) {
            this.fail();
          }
        }, true);
      }

      setBusy(busy) {
        this.busy = busy;
        this.form.setAttribute('aria-busy', String(busy));
        const button = this.form.querySelector('button[type="submit"]');
        if (!button) return;
        button.disabled = busy;
        this.form.querySelector('[type="email"]').readOnly = busy;
        button.querySelector('[data-submit-label]').style.visibility = busy ? 'hidden' : '';
        button.querySelector('.atri-letter__spinner').hidden = !busy;
        const message = this.form.querySelector('[data-loading-message]').textContent;
        if (busy) button.setAttribute('aria-label', message);
        else button.removeAttribute('aria-label');
        this.form.querySelector('[data-loading-status]').textContent = busy ? message : '';
      }

      fail(message) {
        clearTimeout(this.timeout);
        const error = this.form.querySelector('.atri-letter__error');
        if (!error) return;
        error.textContent = message || this.form.querySelector('[data-error-message]').textContent;
        error.hidden = false;
        this.setBusy(false);
      }

      async send() {
        if (!this.busy || this.sending) return;
        this.sending = true;
        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            credentials: 'same-origin',
            signal: this.controller.signal
          });
          const url = new URL(response.url);
          if (url.origin !== window.location.origin) throw new Error('Unexpected response');
          if (/\/challenge(?:\/|$)/.test(url.pathname)) {
            clearTimeout(this.timeout);
            window.location.assign(url.href);
            return;
          }
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.busy) return;
          const returnedForm = html.getElementById(this.form.id);
          const returnedError = returnedForm?.querySelector('.atri-letter__error:not([hidden]), .errors');
          if (returnedError?.textContent.trim()) {
            this.fail(returnedError.textContent.trim());
            const email = this.form.querySelector('[type="email"]');
            email.setAttribute('aria-invalid', 'true');
            email.setAttribute('aria-describedby', this.form.querySelector('.atri-letter__error').id);
            email.focus({ preventScroll: true });
          } else if (response.ok && (url.searchParams.get('customer_posted') === 'true' || returnedForm?.querySelector('.atri-letter__success'))) {
            clearTimeout(this.timeout);
            const success = this.form.querySelector('[data-success-template]').content.cloneNode(true);
            this.setBusy(false);
            this.form.replaceChildren(success);
            this.form.querySelector('.atri-letter__success').focus({ preventScroll: true });
          } else {
            this.fail();
          }
        } catch (error) {
          this.fail();
        } finally {
          this.sending = false;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timeout);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-atri"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-atri-variant]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
